import { Grid, InvestmentDetail } from "../components"
import { Navbar, Footer } from "../layouts"




const HomePage = () => {

    return (
        <>
        <Navbar/>
        <Grid/> 
        <InvestmentDetail/>
        <Footer/>
        </>

    )
}

export default HomePage